export default __webpack_public_path__ + "static/media/44.a047663b.jpg";